import { Component } from '@angular/core';
import { LogoNames } from 'src/app/shared/enums/logoNames.enum';

@Component({
    selector: 'app-product-details',
    templateUrl: './product-details.component.html',
    styleUrls: ['./product-details.component.scss'],
    standalone: false
})
export class ProductDetailsComponent {
    IA = LogoNames.IA;
    PA = LogoNames.PA;
    JA = LogoNames.JA;
}
